


































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import NotificationMixin from "@/mixins/notification.mixin";
import * as _ from "lodash";

const Configurations = namespace("ConfigurationsModule");

@Component({
  name: "Configuration",
  mixins: [NotificationMixin],
  components: {},
})
export default class Configuration extends Mixins(NotificationMixin) {
  loading = false;
  invoiceStatusNew = '';
  paymentTerm = '';
  paymentTermList: Array<any> = [];
  currencySelected: Array<string> = [];
  listCurrencySelected: Array<string> = [];
  envs: Array<any> = [
    {
      status: 1,
      url: 'LG.SFS-360.com',
    },
    {
      status: 1,
      url: 'LHG.SFS-360.com',
    },
    {
      status: 1,
      url: 'LGB.SFS-360.com'
    },
    {
      status: 1,
      url: 'LHGB.SFS-360.com',
    },
    {
      status: 1,
      url: 'HOTEL.SFS-360.com',
    },
    {
      status: 1,
      url: 'ACCAIR.SFS-360.com',
    },
  ];
  invoiceStatusList: Array<any> = [];
  currencies: Array<string> = [];
  extendisConfig: object = {};
  exactConfig: object = {
    ExactApiUrl: '',
    ExactPassword: '',
    ExactUser: '',
  };
  emailConfig = '';
  listEmailConfig: Array<string> = [];

  mounted() {
    this.getData();
  }

  private async getData() {
    await this.getConfig();
    this.listEmailConfig = _.clone(this.EmailConfigurations);
    this.paymentTermList = _.clone(this.PaymentTerms);
    this.invoiceStatusList = _.clone(this.InvoiceStatuses);
    this.exactConfig = _.clone(this.ExactConfig);
    this.currencies = _.clone(this.ListCurrency);
    this.currencySelected = this.Currencies;
    this.addCurrency();
    // this.envs = _.clone(this.Environments);
  }
  private addInvoiceStatus() {
    this.invoiceStatusList.push(this.invoiceStatusNew);
    this.invoiceStatusNew = '';
  }

  private deleteInvoiceStatus(value: any) {
    const index = this.invoiceStatusList.indexOf(value, 0);
    if (index > -1) {
      this.invoiceStatusList.splice(index, 1);
    }
  }

  private addPaymentTerm() {
    if (this.paymentTermList.indexOf(this.paymentTerm) < 0) {
      this.paymentTermList.push(this.paymentTerm);
    }
    this.paymentTerm = '';
  }

  private deletePaymentTerm(value: any) {
    const index = this.paymentTermList.indexOf(value);
    if (index > -1) {
      this.paymentTermList.splice(index, 1);
    }
  }

  private addEmailConfig() {
    if (this.listEmailConfig.indexOf(this.paymentTerm) < 0) {
      this.listEmailConfig.push(this.emailConfig);
    }
    this.emailConfig = '';
  }

  private deleteEmailConfig(value: any) {
    const index = this.listEmailConfig.indexOf(value);
    if (index > -1) {
      this.listEmailConfig.splice(index, 1);
    }
  }

  private addCurrency() {
    const currencySelected = this.currencySelected;
    const listCurrencySelected = this.listCurrencySelected;
    const newCurrency = _.remove(this.currencies, function (item) {
      return currencySelected.indexOf(item) >= 0;
    });
    _.forEach(newCurrency, function (item) {
      listCurrencySelected.push(item);
    })
    this.currencies = [...this.currencies];
    this.currencySelected = [];
  }

  private removeCurrency() {
    const currencySelected = this.currencySelected;
    const currencies = this.currencies;
    const oldCurrency = _.remove(this.listCurrencySelected, function (item) {
      return currencySelected.indexOf(item) >= 0;
    });
    _.forEach(oldCurrency, function (item) {
      if (_.findIndex(currencies, item) < 0) {
        currencies.push(item);
      }
    })
    this.listCurrencySelected = [...this.listCurrencySelected];
    this.currencies = [...this.currencies];
    this.currencySelected = [];
  }

  private async saveConfiguartion() {
    this.loading = true;
    const result = await this.saveConfig({
      ExactConfig: this.exactConfig,
      InvoiceStatuses: this.invoiceStatusList,
      PaymentTerms: this.paymentTermList,
      EmailConfigurations: this.listEmailConfig,
      ExtendisConfig: this.extendisConfig,
      Currencies: this.listCurrencySelected,
    });
    if (result.success) {
      this.onShowFlashMessage("Update configuration successfully!");
    } else {
      this.onShowFlashMessage(result.message, "Error", "danger");
    }
    this.loading = false;
  }

  private hideModal(name: string) {
    switch (name) {
      case 'invoice-status':
        this.invoiceStatusList = _.clone(this.InvoiceStatuses);
        break;
      case 'payment-terms':
        this.paymentTermList = _.clone(this.PaymentTerms);
        break;
      case 'email-config':
        this.listEmailConfig = _.clone(this.EmailConfigurations);
        break;
      case 'exact':
        this.exactConfig = _.clone(this.ExactConfig);
        break;
      case 'extendis':
        this.extendisConfig = _.clone(this.ExtendisConfig);
        break;
      case 'currency':
        this.listCurrencySelected = [];
        this.currencies = _.clone(this.ListCurrency);
        this.currencySelected = this.Currencies;
        this.addCurrency();
        break;
      case 'default':
        break;
    }
  }

  @Configurations.State
  public EmailConfigurations!: Array<string>;

  @Configurations.State
  public PaymentTerms!: Array<string>;

  @Configurations.State
  public InvoiceStatuses!: Array<string>;

  @Configurations.State
  public Environments!: Array<string>;

  @Configurations.State
  public Currencies!: Array<string>;

  @Configurations.State
  public ExactConfig!: object;

  @Configurations.State
  public ExtendisConfig!: object;

  @Configurations.State
  public ListCurrency!: Array<string>;

  @Configurations.Action
  public saveConfig!: (params: object) => Promise<any>;

  @Configurations.Action
  public getConfig!: () => Promise<any>;
}
